import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SecureAuthProvider } from './contexts/SecureAuthContext';
import { DataProvider } from './contexts/DataContext';
import { LicenseProvider } from './contexts/LicenseContext';
import AppRoutes from './routes';
import { Toaster } from 'sonner';
import InstallPWA from './components/InstallPWA';
import OfflineIndicator from './components/OfflineIndicator';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <LicenseProvider>
        <AuthProvider>
          <SecureAuthProvider>
            <DataProvider>
              <AppRoutes />
              <Toaster position="top-right" richColors />
              <InstallPWA />
              <OfflineIndicator />
            </DataProvider>
          </SecureAuthProvider>
        </AuthProvider>
      </LicenseProvider>
    </BrowserRouter>
  );
}

export default App;
